<template>
  <div>
    <div class="flow-root mt-6">
      <ul
        role="list"
        class="-my-5 divide-y divide-gray-200"
      >
        <li
          v-for="queue in queues"
          :key="queue.id"
          class="py-4"
        >
          <div class="flex items-center space-x-4">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-left text-gray-900 capitalize">
                {{ queue.attributes.name }}
              </p>
            </div>
            <div>
              <button
                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                @click="$emit('transfer', queue)"
              >
                Select
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Queue } from '@letsdial/api/src'
  import { onMounted, ref, Ref } from 'vue'
  import useLetsDialAPI from '/@/services/letsDialAPI/useLetsDialAPI'
  import { useAuthStore } from '/@/store/authStore'
  
  const emit = defineEmits<{ transfer: [queue: Queue] }>()
  
  const api = useLetsDialAPI()
  const authStore = useAuthStore()
  const queues: Ref<Array<Queue>> = ref([])
  const loadQueues = async () => {
    if (authStore.selectedOrganization?.id) {
      const queuesResponse = await api.queues.list({
        filter: {
          organizationId: authStore.selectedOrganization?.id,
        },
        fields: { queues: 'name' },
        sort: 'name',
      })
      queues.value = queuesResponse.data ?? []
    }
  }
  onMounted(() => loadQueues())
</script>
